/**
 * Incident Notification Recipients Mapper
 * Maps transport layer DTOs to domain models
 */

import type {
  LC_GetIncidentNotificationRecipientsOut,
  IncidentNotificationRecipient,
} from './incidentNotificationRecipients.types';


export const mapIncidentNotificationRecipients = (
  out: LC_GetIncidentNotificationRecipientsOut,
): IncidentNotificationRecipient[] => {
  if (!out) return [];
  return out.map((item) => ({
    id: item.recipientId,
    description: item.recipientDescription || '',
  }));
};
